<template>
  <div id="app">
    <layout-view>
      <router-view />
    </layout-view>
  </div>
</template>

<script>
import LayoutView from "@/components/layout/index.vue";

export default {
  name: "App",
  components: { LayoutView },
};
</script>

<style lang="scss">
@import "style/app";
</style>
